import React, { Component } from 'react';

import * as util from './util';
import { Header } from './header.js';
import { Footer } from './footer.js';
import { CategorySelectorList } from './category-selector-rewrite';
import { logBusinessActivities } from './business_activities';
import './used-software.css';
import { FeeBoxXU } from './feebox-xu';

import { TextInfo, TextLine, TextField, Price, Confirmed, ConfirmedText, Tags,
         CheckBox, AGBCheckBox, SubmitButton, MultipleFileUpload } from './common-form-components.js';

var introductoryText = '<p>Hier können Kliniken Software, die sie gekauft haben, deren Lizenzen sie aber nicht nutzen, anbieten. Dies wird von Ayacandas begleitet und juristisch abgesicher. <p> Eine kleine Anzahl der Felder sind mit einem "*" gekennzeichnet und <u>müssen</u> ausgefüllt werden. Alle weiteren Felder sind freiwillig. Diese können für mögliche Kunden von Interesse sein.</p>';

let faqSoftware = [
  {
    content: "Immer wieder werden Systeme gewechselt oder durch neue Technologien ersetzt - die Software, die dafür teuer gekauft wurde, bleibt dann oft ungenutzt liegen. Hier soll die Möglichkeit gegeben werden, ungenutzte Software-Lizenzen noch zu verkaufen. <br /> <br /> Denn es zeigt sich, dass viele Kliniken z.B. noch mit alter Software arbeiten, so dass für diese auch ältere Versionen sehr nützlich sein können. ",
    title: "Wozu der Bereich der Gebrauchtsoftware?",
    key: 0
  },
  {
    content: "Der Europäische Gerichtshof führt in seinem Urteil aus, dass der Grundsatz der Erschöpfung des Verbreitungsrechts nicht nur dann gilt, wenn der Urheberrechtsinhaber die Kopien seiner Software auf einem Datenträger (CD-ROM oder DVD) vermarktet, sondern auch dann, wenn er sie durch Herunterladen von seiner Internetseite verbreitet. In diesem Zusammenhang stellt der Gerichtshof klar, dass jeder spätere Erwerber einer Kopie, für die das Verbreitungsrecht des Urheberrechtsinhabers erloschen ist, rechtmäßiger Erwerber in diesem Sinne ist. Er kann also die ihm vom Ersterwerber verkaufte Kopie auf seinen Computer herunterladen. Dieses Herunterladen ist als Vervielfältigung eines Computerprogramms anzusehen, die für die bestimmungsgemäße Nutzung dieses Programms durch den neuen Erwerber erforderlich ist … <br /> <br /> EuGH (3/7/12, RsC-128/11)<br /><br /> „… Außerdem erstreckt sich die Erschöpfung des Verbreitungsrechts auf die Programmkopie in der vom Urheberrechtsinhaber verbesserten und aktualisierten Fassung …“ <br /><br /> EuGH (3/7/12, RsC-128/11)",
    title: "Wie verhält sich der Verkauf rechtlich? ",
    key: 1
  },
  {
    content: "Nein. Keine.<br /><br />„… Weiter führt der Gerichtshof aus, dass der ursprüngliche Erwerber einer körperlichen oder nichtkörperlichen Programmkopie, an der das Verbreitungsrecht des Erwerbers erschöpft ist, die auf seinen Computer heruntergeladene Kopie zum Zeitpunkt des Weiterverkaufs unbrauchbar machen muss …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />",
    title: "Darf ich noch Kopien der entsprechenden Software behalten? ",
    key: 2
  },
  {
    content: "Klare Antwort: Ja, wenn diese vollständig verkauft werden. Bei allen anderen Versionen besteht zumindest ein Nachweis-Problem, dass einen in eine rechtlich dunkelgraue Zone führt.<br /><br />„… Stellt der Urheberrechtsinhaber seinem Kunden nämlich eine – körperliche oder nichtkörperliche – Kopie zur Verfügung, und schließt er gleichzeitig gegen Zahlung eines Entgelts einen Lizenzvertrag, durch den der Kunde das unbefristete Nutzungsrecht an dieser Kopie erhält, so verkauft er diese Kopie an den Kunden und erschöpft damit sein ausschließliches Verbreitungsrecht. Durch ein solches Geschäft wird nämlich das Eigentum an dieser Kopie übertragen. Somit kann sich der Rechtsinhaber, selbst wenn der Lizenzvertrag eine spätere Veräußerung untersagt, dem Weiterverkauf dieser Kopie nicht mehr widersetzen …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />„… Der Gerichtshof weist jedoch darauf hin, dass die Erschöpfung des Verbreitungsrechts den Ersterwerber nicht dazu berechtigt, die Lizenz aufzuspalten und teilweise weiterzuverkaufen, falls die von ihm erworbene Lizenz für eine seinen Bedarf übersteigende Zahl von Nutzern gilt …“<br /><br />EuGH (3/7/12, RsC-128/11)<br /><br />",
    title: "Können Volumenverträge weiterverkauft werden? ",
    key: 3
  },
  {
    content: "Der Verkauf erfolgt direkt von Ihnen zum Käufer, die Firma Ayacandas bekommt eine Vermittlungsgebühr.",
    title: " Wie geht der Verkauf über die Firma Ayacandas?",
    key: 4
  },

];

export class CreateUsedSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.fetchDataAndRedirect();
  }

  fetchDataAndRedirect() {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-used-software`;
    var promise = fetch(url, {method: 'POST',
                              headers: headers,
                              body: ''
    })
      .then(response => response.json())
      .catch(function(exception) {
        alert('Konnte keine neue Software anlegen!');
        console.error(`Could not create new software!`, exception);
      });
    promise.then(function(json) {
      self.props.history.replace(`/update-used-software/${json.id}`);
    });
  }

  render() {
    return(
      <div className="CreateUsedSoftware">
      </div>
    )
  }
}

export class UpdateUsedSoftwareWithFeebox extends Component {
  constructor(props) {
    super(props);
    this.updateFeeByPrice = this.updateFeeByPrice.bind(this);
    this.updateFeeByCategories = this.updateFeeByCategories.bind(this);
    this.countCategories = this.countCategories.bind(this);
    this.state={price: 0,
                categoryCount: 1};
  }

  updateFeeByPrice(price) {
    this.setState({price: price});
    return true;
  }

  updateFeeByCategories (categories) {
    this.setState ({categoryCount:this.countCategories(categories)});
    return true;
  }


  countCategories(categories) {
    // workaround: converting String to array (FIXME)
    if ((typeof categories ) === 'string') {
      categories = categories.split(",");
    }
     console.log(categories);
     var tempCats = [];
     var count = 0;
     for (let i = 0; i < 6; i++) {
      if (categories !== undefined && categories[i] !== null && categories[i] !== "" ) {
        if (!tempCats.includes(categories[i])) {
          tempCats.push(categories[i]);
          count = count+1;
        } 
      }
    }
    return count;
  }


  render() {
    return (
      <div className="UpdateUsedSoftwareWithFeebox" >
        <UpdateUsedSoftware history={this.props.history} match={this.props.match} updateFeeByPrice={this.updateFeeByPrice} updateFeeByCategories={this.updateFeeByCategories} />
        {util.isCommercialUser() &&
         <FeeBoxXU type="software" price={this.state.price} categoryCount={this.state.categoryCount} />}
      </div>
    )
  }
}


export class UpdateUsedSoftware extends Component {
  constructor(props) {
    super(props);
    this.fetchDataAndRedirect = this.fetchDataAndRedirect.bind(this);
    this.update = this.update.bind(this);
    this.validateInput = this.validateInput.bind(this);
    this.checkRequiredFields = this.checkRequiredFields.bind(this);
    this.isValid = this.isValid.bind(this);
    this.save = this.save.bind(this);

    this.state = {
      startID: 2,
      id: null,
      name: '',
      categories: '',
      price: 0,
      aim: '',
      tags: '',
      desc: '',
      agb_agreement: false,
      is_public: false,
      is_update_available: false,
      update_price_text: '',
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: '',
      product_files: '',
      agreement_1: false,
      agreement_2: false,
      agreement_3: false,
      agreement_4: false,
      agreement_6: false,
      // new for used-software
      company: '',
      company_name: '',
      company_web: '',

    };

    this.fetchDataAndRedirect();
    this.globalFormData = {};
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  update(slot, value) {
    if(slot === 'price' && this.props.updateFeeByPrice !== undefined) {
      this.props.updateFeeByPrice(parseInt(value, 10));
    }
    if(slot === 'categories' && this.props.updateFeeByCategories !== undefined) {
      this.props.updateFeeByCategories(value);
    }

    this.globalFormData[slot] = value;
  }


  fetchDataAndRedirect() {
    var id = this.props.match.params['id'];
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    var url = `/api/create-used-software`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: `id=${id}`
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte laden!');
        console.error(`Could not retrieve used-oftware data!`, exception);
      });
    promise.then(function (json) {
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        is_public: json.is_public,
        is_update_available: json.is_update_available,
        update_price: json.update_price,
        update_price_text: json.update_price_text,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
        agreement_6: json.agreement_6,
        // new to used-software
        company: json.company,
        company_name: json.company_name,
        company_web: json.company_web,
      });
    })
  }

  isValid(categories) {

    if (categories === undefined)
      return false;

    if (categories === null)
      return false;

    if (categories === "")
      return false;

    if (typeof categories === 'string') {
      categories = categories.split(/,/);
    }

    var catInput = categories.map(item => parseInt(item, 10));
    for (var i = 0; i < categories.length; i++) {
      if (parseInt(catInput[i], 10) === catInput[i]) {
        return true;
      }
    }
    return false;
  }

  validateInput() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length > 200) {
        alert("Der Name ist zu lang, bitte beschrenken Sie sich auf 200 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length <= 3) {
        alert("Der Name ist zu kurz, bitte geben Sie einen Namen mit mindestens vier Buchstaben ein.");
        return false;
      }
      if (this.globalFormData['name'].length > 200) {
        alert("Der Name ist zu lang, bitte beschränken Sie sich auf 200 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length <= 9) {
        alert("Die Beschreibung ist zu kurz. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");
        return false;
      }
      if (this.state.aim.length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length <= 9) {
        alert("Die Beschreibung ist zu kurz. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");
        return false;
      }
      if (this.globalFormData['aim'].length > 2000) {
        alert("Die Beschreibung ist zu lang, bitte beschränken Sie sich auf 2000 Zeichen.");
        return false;
      }
    }
    return true;
  }

  checkRequiredFields() {
    if (this.globalFormData['name'] === undefined) {
      if (this.state.name.length <= 3) {
        alert("Der Name ist ein Pflichtfeld. Bitte geben Sie mindestens vier Zeichen ein.");
        return false;
      }
    } else {
      if (this.globalFormData['name'].length <= 3) {
        alert("Der Name ist ein Pflichtfelder. Bitte geben Sie mindestens vier Zeichen ein.");
        return false;
      }
    }

    if ((this.globalFormData['categories'] === undefined) && (!this.isValid(this.state.categories))) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }
    if (!this.isValid(this.globalFormData['categories'])) {
      alert("Geben Sie wenigstens eine und bis zu sechs Kategorien an.");
      return false;
    }

    if (this.globalFormData['aim'] === undefined) {
      if (this.state.aim.length <= 9) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");
        return false;
      }
    } else {
      if (this.globalFormData['aim'].length <= 9) {
        alert("Der Zweck ist ein Pflichtfeld. Bitte beschreiben Sie Ihr Angebot mit mindestens 10 Zeichen.");
        return false;
      }
    }

    if (this.globalFormData['price'] === undefined) {
      if (this.state.price.length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    } else {
      if (this.globalFormData['price'].length === 0) {
        alert("Der Preis ist ein Pflichtfeld. Bitte geben Sie den Preis an.");
        return false;
      }
    }


    if (this.globalFormData['agreement_2'] === undefined) {
      if (this.state.agreement_2 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_2'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }

    if (this.globalFormData['agreement_3'] === undefined) {
      if (this.state.agreement_3 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_3'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agreement_4'] === undefined) {
      if (this.state.agreement_4 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_4'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }


    if (this.globalFormData['agreement_6'] === undefined) {
      if (this.state.agreement_6 !== true) {
        alert("Bitte stimmen Sie der Erklärung zu.");
        return false;
      }
    }

    if (this.globalFormData['agreement_6'] === false) {
      alert("Bitte stimmen Sie der Erklärung zu.");
      return false;
    }



    if (this.globalFormData['agb_agreement'] === false) {
      alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
      return false;
    }

    if (this.globalFormData['agb_agreement'] === undefined) {
      if (this.state.agb_agreement !== true) {
        alert("Bitte bestätigen Sie, dass Sie die Vereinbarung zu Kenntnis genommen haben.");
        return false;
      }
    }

    return true;
  }

  save(announce) {
    if (announce === true) {
      if (this.checkRequiredFields() === false) {
        return;
      }
    }

    if (announce === true) {
      if (this.validateInput() === false) {
        return;
      }
    }
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var formData = new FormData();
    Object.keys(this.globalFormData).map(key => formData.append(key, self.globalFormData[key]));
    formData.append("id", this.state.id);
    if (announce === true) {
      formData.append('announce', true);
    } else {
      formData.append('announce', false);
    }
    formData.append('active', true);
    var url = `/api/update-used-software`;
    var promise = fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte keine Werte speichern!');
        console.error(`Could not save used-software data!`, exception);
      });
    promise.then(function (json) {
      alert('Werte wurden gespeichert.');
      if (announce === true) {
        logBusinessActivities("Software gespeichert, allem zugestimmt und veroeffentlicht.", json.id);
      }
      self.globalFormData = {};
      self.setState({
        id: json.id,
        name: json.name,
        desc: json.desc,
        categories: json.categories,
        price: json.price,
        aim: json.aim,
        tags: json.tags,
        agb_agreement: json.agb_agreement,
        is_public: json.is_public,
        is_update_available: json.is_update_available,
        update_price_text: json.update_price_text,
        pdf_files: json.pdf_files,
        image_files: json.image_files,
        video_files: json.video_files,
        product_files: json.product_files,
        agreement_2: json.agreement_2,
        agreement_3: json.agreement_3,
        agreement_4: json.agreement_4,
        agreement_6: json.agreement_6,
        // new to used-software
        company: json.company,
        compnay_name: json.company_name,
        compnay_web: json.company_web,
      });
      self.props.history.push('/product-list');
    })
  }
  render() {
    return (
      <div>
        {util.isNonCommercialUser() &&
          <div className="Landing" id="contentId">
          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
             <div className="content" id="content">
               <div className="productHeader1" id="toplanding">
                 Anbieten einer Gebrauchtsoftware
               </div>
               <div className="productHeader2">
                 Nach abgeschlossener Einstellung Ihres Angebotes bleibt
                 dieses für ein Jahr auf der Ayacandas.com zum angegebenen
                 Preis auffindbar.
                 <TextInfo content={introductoryText} />
               </div>
          
          <div className="productForm1  marginTop30">

            <div className="prodInputComp">
           <TextLine heading=" Was bieten Sie an?" subheading="Unter diesem Titel wird ihr Produkt angezeigt." obligatory={true} maxLength='200' value={this.state.name} placeholder="was bieten Sie an" slot='name' update={this.update} />
           </div>
           <TextField heading="Beschreibung" obligatory={true} maxLength='2000' value={this.state.aim} placeholder="Zweck" slot='aim' update={this.update} />
           <CategorySelectorList value={this.state.categories} slot="categories" update={this.update} categoryLimit={6} />
           <TextField heading="Hersteller" obligatory={false} placeholder="Firma" value={this.state.company} slot='company' update={this.update} />
           <TextField heading="Genaue Herstellerbezeichnung der Software" obligatory={false} placeholder="Bezeichnung durch Firma" value={this.state.company_name} slot='company_name' update={this.update} />
           <TextField heading="Gibt es eine Hersteller-Webseite mit genaueren Informationen über die Software?" obligatory={false} placeholder="Firmenwebseite" value={this.state.company_web} slot='company_web' update={this.update} />
           {!util.isCommercialUser() && <Price heading="Preis in Euro"
                                               subheading="85% des Netto-Preises, den Ayacandas durch den Weiterverkauf Ihres Produktes erzielt, wird Ihnen oder Ihrer Institution für das Zurverfügungstellen der Lizenz ausbezahlt." obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}
           {util.isCommercialUser() && <Price heading="Preis in Euro"
                                              obligatory={true} maxLength='6' value={this.state.price} slot='price' update={this.update} />}
           <Confirmed obligatory={false} heading="Ist die Software ein Medizinprodukt?" value={this.state.is_public} slot='is_public' update={this.update} />
           <ConfirmedText heading="Muss die Software aktualisiert werden?"
                          placeholder="Update/Wartung"
                          value={this.state.is_update_available} value2={this.state.update_price_text}
                          slot='is_update_available' slot2='update_price_text' update={this.update} />
           <Tags heading="Stichworte, um gefunden zu werden (max. 7, durch Komma getrennt)" placeholder="Tags/Stichworte" value={this.state.tags} slot='tags' update={this.update} match={this.props.match} maxTags={7} maxLength={150} onNewMessage={this.props.onNewMessage} />
           <MultipleFileUpload heading="Anhang: Dokumente, vorzugsweise als PDF-Datei (bitte nur fachliches Material)" value={this.state.pdf_files} slot="pdf_files" update={this.update} onNewMessage={this.props.onNewMessage} />
           <MultipleFileUpload heading="Anhang: Beschreibende Bilder oder Screenshotst" value={this.state.image_files} slot="image_files" update={this.update} onNewMessage={this.props.onNewMessage} />
           <MultipleFileUpload heading="Anhang: Video, max. 5 GB" value={this.state.video_files} slot="video_files" update={this.update} onNewMessage={this.props.onNewMessage} />
           <MultipleFileUpload heading="Hier haben Sie die Möglichkeit, Ihr Produkt als eine Datei hochzuladen." value={this.state.product_files} slot="product_files" update={this.update} onNewMessage={this.props.onNewMessage} />
           <CheckBox heading="* Erklärung zum Besitz" content="Ich kann den Kauf der Lizenz oder der Nutzungserlaubnis der Software-Lizenzen nachweisen." value={this.state.agreement_2} slot='agreement_2' update={this.update} />
           <CheckBox content="Ich bin mit dem Preis zum Einstellen der Software in den Marktplatz einverstanden." value={this.state.agreement_3} slot='agreement_3' update={this.update} />
           <CheckBox content="Hiermit garantiere ich, dass ich im Falle eines Verkaufs die Software und die zugehörigen Lizenzschlüssel von allen mir bekannten Medien löschen werde." value={this.state.agreement_4} slot='agreement_4' update={this.update} />
           <CheckBox content="Ich werde als Ansprechpartner für das Angebot zur Verfügung stehen." value={this.state.agreement_6} slot='agreement_6' update={this.update} />
           {!util.isCommercialUser() &&
            <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/ueberlassungsvereinbarung.pdf"
                         content1="Ich habe die " fileType="Überlassungsvereinbarung" content2=" gelesen und akzeptiere diese." update={this.update} />}
            {util.isCommercialUser() &&
             <AGBCheckBox value={this.state.agb_agreement} slot='agb_agreement' agbUrl="/einstellvertrag.pdf"
                          content1="Ich habe den " fileType="Einstellvertrag" content2=" gelesen und akzeptiere diesen." update={this.update} />}<br /><br />
          <div className="textUsed">
            Im Falle eines Verkaufs werden die Software und die zugehörigen Lizenzschlüssel gelöscht.
          </div>
             
         </div>
         <SubmitButton  history={this.props.history} onSubmit={this.save} />
         </div>
         </div>
         <Footer faqs={faqSoftware} />
         </div>
        }
         {!util.isNonCommercialUser() &&
          <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
           <div className="ContentWithBackground">
           <div className="content" id="content">
               <div className="productHeader1">
               Sie besitzen nicht genügend Rechte, um eine Gebraucht-Software zu erstellen.
                 </div>
           </div>
           </div>
         <Footer faqs={faqSoftware} />
         </div>
               }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/used-software.js